export interface SupplierApiResponse {
  id: number;
  organizationId: string;
  organizationName: string;
  organizationAddress: string;
  manufacturer: string;
  packagingName: string;
  commissioned: string;
  boxSize: string;
  price: string;
  salesPrice: string;
  minimumValueOrder: string;
  shortageSurcharge: string;
}

export interface SupplierModel {
  id: number;
  organizationId: string;
  organizationName: string;
  organizationAddress: string;
  manufacturer: string;
  packagingName: string;
  commissioned: string;
  boxSize: string;
  price: string;
  salesPrice: string;
  minimumValueOrder: string;
  shortageSurcharge: string;
  isImportedNapo?: undefined | string;
  defaultSupplierPosition?: number;
}

interface SimplifiedSupplierModel {
  id: number;
  name: string;
  address: string;
  salesPrice?: string;
  defaultSupplierPosition?: number;
  isImportedNapo?: string;
}

export class SimplifiedSupplier implements SimplifiedSupplierModel {
  id = -1;
  name = '';
  address = '';
  salesPrice? = '';
  defaultSupplierPosition? = -1;
  isImportedNapo? = '';

  constructor(dto?: SimplifiedSupplierModel) {
    if (!dto) {
      return;
    }

    this.id = dto.id;
    this.name = dto.name;
    this.address = dto.address;
    this.salesPrice = dto.salesPrice;
    this.defaultSupplierPosition = dto.defaultSupplierPosition;
    this.isImportedNapo = dto.isImportedNapo;
  }
}

export class Supplier implements SupplierModel {
  id = -1;
  organizationId = '';
  organizationName = '';
  organizationAddress = '';
  manufacturer = '';
  packagingName = '';
  commissioned = '';
  boxSize = '';
  price = '';
  salesPrice = '';
  minimumValueOrder = '';
  shortageSurcharge = '';
  isImportedNapo? = '';
  defaultSupplierPosition? = -1;

  constructor(dto?: SupplierModel) {
    if (!dto) {
      return;
    }
    this.id = dto.id;
    this.organizationId = dto.organizationId;
    this.organizationName = dto.organizationName;
    this.organizationAddress = dto.organizationAddress;
    this.manufacturer = dto.manufacturer;
    this.packagingName = dto.packagingName;
    this.commissioned = dto.commissioned;
    this.boxSize = dto.boxSize;
    this.price = dto.price;
    this.salesPrice = dto.salesPrice;
    this.minimumValueOrder = dto.minimumValueOrder;
    this.shortageSurcharge = dto.shortageSurcharge;
    this.isImportedNapo = dto.isImportedNapo;
  }

  static parseDTO(dto: SupplierApiResponse): Supplier {
    return new Supplier({
      id: dto.id,
      organizationId: dto.organizationId,
      organizationName: dto.organizationName,
      organizationAddress: dto.organizationAddress,
      manufacturer: dto.manufacturer,
      packagingName: dto.packagingName,
      commissioned: dto.commissioned,
      boxSize: dto.boxSize,
      price: dto.price,
      salesPrice: dto.salesPrice,
      minimumValueOrder: dto.minimumValueOrder,
      shortageSurcharge: dto.shortageSurcharge
    });
  }
}
